const verifyReaplyConcByTimeAsync = (func, successCallback, errorCallback, wait) => {
  func()
    .then((response) => {
      // se nao houver conciliacao pendente
      if (response.data.data === true) {
        successCallback(response)
        return
      // se ocorreu um erro
      } else if (response.data.data === null) {
        errorCallback()
      }
      setTimeout(() => verifyReaplyConcByTimeAsync(func, successCallback, errorCallback, wait), wait)
    }).catch((err) => {
      errorCallback(err)
    })
}

const verifyReaplyConcTimeout = 10000

export {
  verifyReaplyConcByTimeAsync,
  verifyReaplyConcTimeout
}



// WEBPACK FOOTER //
// ./client/utils/verifyReaplyConcByTimeAsync.js